<template>
  <div class="container aboutme">
     <!-- <header>
        <div class="user_img">
          <img src="../../assets/img/user.png" alt="">
        </div>
        <p class="user_name">您好，{{userDetail.realName}}</p>
        <p class="user_des">「 心是一个人的翅膀，心有多大，世界就有多大 」</p>
        <img src="../../assets/img/user_header_bg.png" alt="" class="bg">
     </header> -->
     <ul>
       <li class="list_item border">
         <router-link :to="{ path: '/my/welfare' }">
            <i class="icon welfare"></i>
            <p class="txt">我的福利</p>
            <i class="arrow_right"></i>
         </router-link>
       </li>
       <li class="list_item" :class="{border:isWxwork}">
         <router-link :to="{ path: '/my/cards' }">
            <i class="icon care"></i>
            <p class="txt">我的关怀消息</p>
            <i class="arrow_right"></i>
         </router-link>
       </li>
       <div class="space_bg"  v-if="!isWxwork"></div>
       <li class="list_item border">
         <router-link :to="{ path: '/my/activity' }">
            <i class="icon activity"></i>
            <p class="txt">我的活动</p>
            <span class="tips">玩过的活动都在这里哦</span>
            <i class="arrow_right"></i>
         </router-link>
       </li>
       <li class="list_item" v-if="!isWxwork">
         <a href="//g.aghcdn.com/giftlist">
            <i class="icon gift"></i>
            <p class="txt">我的微礼</p>
            <i class="arrow_right"></i>
         </a>
       </li>
       <div class="space_bg"></div>
       <li class="list_item">
         <router-link :to="{ path: '/address' }">
            <i class="icon address"></i>
            <p class="txt">地址管理</p>
            <i class="arrow_right"></i>
         </router-link>
       </li>
       <div class="space_bg"></div>
       <li class="list_item">
         <router-link :to="{ path: '/help' }">
            <i class="icon help"></i>
            <p class="txt">售后服务</p>
            <i class="arrow_right"></i>
         </router-link>
       </li>
     </ul>
     <!-- </div> -->
    <!--  <template v-if="isShowMergeNav==0">
        <fmenu></fmenu>
     </template> -->
     <home :ishome=0></home>
  </div>
</template>
<script>
import {
    mapGetters,
    mapActions
} from 'vuex'
// import fmenu from '../common/nav'
import home from '../common/home.vue'
export default {
  data () {
    return {
     	 loading:true
    }
  },
  components:{
    home
  },
  computed:{   	 	 
  	 ...mapGetters({
       userDetail:'getuserDetail',
       isShowMergeNav:'getisShowMergeNav',
       isWxwork:'getisWxAgent'
    })
  },
  watch:{
    userDetail(cval){
      if(cval){
        this.loading=false;
      }
    }
  },
  created(){
    this.$store.dispatch('loaduserDetail')
  },
  methods:{
      
  },
  mounted(){}
}
</script>